// (function () {
//   'use strict';

//   // Set default selected variant on load (first available pill)
//   document.querySelectorAll('.card-variant-quick-add').forEach(function (wrap) {
//     const input = wrap.querySelector('input[name="id"]');
//     const first = wrap.querySelector('.pill.is-selected:not([disabled])') || wrap.querySelector('.pill:not([disabled])');
//     const submit = wrap.querySelector('button[type="submit"]');
//     if (first && input) input.value = first.dataset.variantId;
//     if (submit) submit.disabled = first ? first.hasAttribute('disabled') : true;
//   });

//   // Change variant when a pill is clicked
//   document.addEventListener('click', function (e) {
//     const pill = e.target.closest('.card-variant-quick-add .pill');
//     if (!pill) return;
//     const wrap = pill.closest('.card-variant-quick-add');
//     const input = wrap.querySelector('input[name="id"]');
//     const submit = wrap.querySelector('button[type="submit"]');

//     wrap.querySelectorAll('.pill').forEach(b => b.classList.remove('is-selected'));
//     pill.classList.add('is-selected');

//     if (input) input.value = pill.dataset.variantId;
//     if (submit) submit.disabled = pill.hasAttribute('disabled');
//   }, false);
// })();


(function () {
  'use strict';

  document.querySelectorAll('.card-variant-quick-add').forEach(function (wrap) {
    const submit = wrap.querySelector('button[type="submit"]');

    // --- DROPDOWN path ---
    const select = wrap.querySelector('select[name="id"]');
    if (select) {
      // preselect first enabled option
      const firstEnabled = Array.from(select.options).find(o => !o.disabled);
      if (firstEnabled) select.value = firstEnabled.value;
      if (submit) submit.disabled = !firstEnabled;

      select.addEventListener('change', function () {
        if (submit) {
          const opt = select.selectedOptions[0];
          submit.disabled = opt ? opt.disabled : true;
        }
      });
      return; // do not run the pills code below
    }

    // --- PILLS path (kept for compatibility) ---
    const input = wrap.querySelector('input[name="id"]');
    const firstPill = wrap.querySelector('.pill.is-selected:not([disabled])') || wrap.querySelector('.pill:not([disabled])');
    if (firstPill && input) input.value = firstPill.dataset.variantId;
    if (submit) submit.disabled = firstPill ? firstPill.hasAttribute('disabled') : true;

    document.addEventListener('click', function (e) {
      const pill = e.target.closest('.card-variant-quick-add .pill');
      if (!pill || !wrap.contains(pill)) return;

      wrap.querySelectorAll('.pill').forEach(b => b.classList.remove('is-selected'));
      pill.classList.add('is-selected');

      if (input) input.value = pill.dataset.variantId;
      if (submit) submit.disabled = pill.hasAttribute('disabled');
    }, false);
  });
})();
